import React from 'react';
import { ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Mascot } from './Mascot';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Process() {
  const {
    t
  } = useLanguage();
  return <section id="process" className="w-full bg-white py-16 lg:py-20" data-id="element-228" data-mp="23d8n65cg9toe">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-229" data-mp="16oaquip1xnp4">
        <SectionHeading eyebrow={t.process.eyebrow} title={t.process.title} subtitle={t.process.subtitle} data-id="element-230" data-mp="16ly0bh58a50g" />

        <ol className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4" data-id="element-231" data-mp="1fo7d6dnyyah0">
          {t.process.steps.map((step, index) => <Reveal as="li" key={step.id} delay={index * 0.05} className="relative" data-id="element-232" data-mp="1kgqp7670cxjp" data-mpi={index}>
              <div className="flex items-start gap-4 lg:flex-col lg:items-start lg:gap-0" data-id="element-233" data-mp="mzih4t1rsvc4">
                <div className="relative shrink-0 lg:mb-5" data-id="element-234" data-mp="rxtql2o5l3tt">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-500 font-display text-xl font-extrabold text-ink" data-id="element-235" data-mp="19kzhykojzvb5">
                    {index + 1}
                  </span>
                  {index === 0 ? <Mascot size={28} tone="light" animate className="absolute -right-2 -top-2 shadow-card" data-id="element-236" data-mp="10rcoj17tj454" /> : null}
                </div>
                <div data-id="element-237" data-mp="lv53xzsi00pb">
                  <h3 className="font-display text-base font-extrabold uppercase tracking-wide text-ink" data-id="element-238" data-mp="luvfign3q1lq">
                    {step.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#5B5B5B]" data-id="element-239" data-mp="cv8dbsmjsrrm">{step.description}</p>
                </div>
              </div>

              {index < t.process.steps.length - 1 ? <ChevronRightIcon className="absolute right-[-14px] top-[13px] hidden h-6 w-6 text-brand-300 lg:block" aria-hidden="true" data-id="element-240" data-mp="2799am92g96pl" /> : null}
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-241" data-mp="2v5mccor081hc">
          <div className="mt-14 flex flex-col items-center gap-4 border-t border-black/10 pt-10 sm:flex-row sm:justify-center" data-id="element-242" data-mp="2hcwrinn7p2lt">
            <a href="#contact" className="group inline-flex items-center gap-2 rounded bg-brand-500 px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-colors duration-200 ease-smooth hover:bg-brand-400" data-id="element-243" data-mp="2mb81cydibd41">
              {t.process.cta}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-244" data-mp="302cvjky3vd6z" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}